import { ContentBlock } from "../../types/contentBlock";
import { ServiceListBlock } from "../../types/serviceListBlock";
import { AssetQuery } from "./asset";

export const serviceListBlockQuery = `
    _type == "serviceListBlock" => {
    title,
    text,
    services[] {
        serviceReference {
            ...,
            service -> {
                images,
                title
            },
        },
        customImages
    },
}`;

export const isServiceListBlock = (solution: ContentBlock): solution is ServiceListBlock => {
    return solution._type === 'serviceListBlock';
}